var NetworkStructure = /** @class */ (function () {
    function NetworkStructure(data) {
        if (data === void 0) { data = null; }
        this._nodes = {};
        this._onNodeAddedCallbacks = [];
        this._onLinkAddedCallbacks = [];
        this._onNodesRemovedCallbacks = [];
        this._onLinksRemovedCallbacks = [];
        this._links = {};
        this.data = data;
    }
    NetworkStructure.prototype.subscribeOnNodeAdded = function (callback) {
        this._onNodeAddedCallbacks.push(callback);
    };
    NetworkStructure.prototype.subscribeOnLinkAdded = function (callback) {
        this._onLinkAddedCallbacks.push(callback);
    };
    NetworkStructure.prototype.subscribeOnNodesRemoved = function (callback) {
        this._onNodesRemovedCallbacks.push(callback);
    };
    NetworkStructure.prototype.subscribeOnLinksRemoved = function (callback) {
        this._onLinksRemovedCallbacks.push(callback);
    };
    NetworkStructure.prototype.getSourceNodeFromTargetNode = function (id) {
        var _this = this;
        var keys = Object.keys(this._links);
        var key = keys.filter(function (x) { return _this._links[x][id]; })[0];
        return this._nodes[key];
    };
    NetworkStructure.prototype.findNodeById = function (id) {
        return this._nodes[id];
    };
    NetworkStructure.prototype.findNodeByText = function (text) {
        var _this = this;
        var keys = Object.keys(this._nodes);
        var key = keys.filter(function (key) { return _this._nodes[key].text == text; })[0];
        return this._nodes[key];
    };
    NetworkStructure.prototype.addNode = function (networkNode) {
        var _this = this;
        this._nodes[networkNode.id] = networkNode;
        this._onNodeAddedCallbacks.forEach(function (callback) {
            callback(_this._nodes[networkNode.id]);
        });
    };
    NetworkStructure.prototype.addLink = function (link) {
        var _this = this;
        if (!this._links[link.sourceId]) {
            this._links[link.sourceId] = {};
        }
        this._links[link.sourceId][link.targetId] = link;
        this._onLinkAddedCallbacks.forEach(function (callback) {
            callback(_this._links[link.sourceId][link.targetId]);
        });
    };
    NetworkStructure.prototype.removeNode = function (id, removeSubtree) {
        var _this = this;
        if (removeSubtree === void 0) { removeSubtree = true; }
        var removedNodes = [];
        var node = this._nodes[id];
        var keys = Object.keys(this._links);
        var sourceNodeId = keys.filter(function (x) { return _this._links[x][id]; })[0];
        var subTreeNodes = [];
        if (node != null) {
            subTreeNodes = this.getSubtree(node);
            removedNodes = subTreeNodes.map(function (x) { return x.id; });
            subTreeNodes.forEach(function (n) {
                delete _this._links[n.id];
                delete _this._nodes[n.id];
            });
            delete this._nodes[id];
            delete this._links[id];
            if (sourceNodeId) {
                delete this._links[sourceNodeId][id];
            }
            removedNodes.push(id);
            subTreeNodes = subTreeNodes.concat([node]);
            this._onNodesRemovedCallbacks.forEach(function (callback) {
                callback(subTreeNodes);
            });
        }
        return subTreeNodes;
    };
    NetworkStructure.prototype.getSubtree = function (node) {
        var _this = this;
        var idsLinked = this._links[node.id] ? Object.keys(this._links[node.id]) : [];
        var linkedNodes = idsLinked.map(function (id) { return _this._nodes[id]; });
        linkedNodes.slice(0).forEach(function (linkedNode) {
            linkedNodes = linkedNodes.concat(_this.getSubtree(linkedNode));
        });
        return linkedNodes;
    };
    NetworkStructure.prototype.getLink = function (source, target) {
        return this._links[source][target];
    };
    NetworkStructure.prototype.getLinks = function () {
        var temp = [];
        for (var key in this._links) {
            for (var key2 in this._links[key]) {
                temp.push(this._links[key][key2]);
            }
        }
        return temp;
    };
    NetworkStructure.prototype.getRootNode = function () {
        return this.getNodes().filter(function (x) { return x.level == 0; })[0];
    };
    NetworkStructure.prototype.getNodes = function () {
        var temp = [];
        for (var key in this._nodes) {
            temp.push(this._nodes[key]);
        }
        return temp;
    };
    return NetworkStructure;
}());
export { NetworkStructure };
var NetworkNode = /** @class */ (function () {
    function NetworkNode() {
        this.applyDefaults();
    }
    NetworkNode.prototype.applyDefaults = function () {
        this.fontColor = '#343434';
        this.fontSize = 14;
        this.fontFace = "arial";
        this.fontBackground = "none";
        this.size = null;
    };
    return NetworkNode;
}());
export { NetworkNode };
var NetworkLink = /** @class */ (function () {
    function NetworkLink(sourceId, targetId, text, data) {
        if (text === void 0) { text = ""; }
        if (data === void 0) { data = null; }
        this.sourceId = sourceId;
        this.targetId = targetId;
        this.text = text;
        this.data = data;
    }
    return NetworkLink;
}());
export { NetworkLink };
